// extracted by mini-css-extract-plugin
export default {"level3":"WifiSvg_level3__FCIyZ","level2":"WifiSvg_level2__jMJEZ","level1":"WifiSvg_level1__G0P0E","level0":"WifiSvg_level0__wqwYf"};